import { INavGroup, requiredRoles } from 'lib';
import { DICTIONARY_PATHS } from './dictionary-paths';
import { EDGE_DEFINITION_PATHS } from './edge-definition-paths';
import { GLOSSARY_METADATA_PATHS } from './glossary-metadata-paths';
import { JOB_MANAGER_PATHS } from './job-manager-paths';
import { SINGLE_NAVIGATION_PATHS } from './single-navigation-paths';
import { WALLETS_AND_GROUPS_PATHS } from './wallets-and-groups-paths';
import { CONSENT_CONTRACT_PATHS } from './consent-contracts-paths';
import { SMART_CONTRACT_PATHS } from './smart-contracts-paths';
import { PIPELINES_AND_STEPS_PATHS } from './pipelines-and-steps-paths';

export const AppName = 'Godzilla UI';
export const CustomerName = localStorage.getItem('realm');
export const MUI_GRID_PRO_KEY =
    'cd63165ab9469dfdd9de44f97e3c63d5T1JERVI6NDE4OTcsRVhQSVJZPTE2ODE1NzQxMDgwMDAsS0VZVkVSU0lPTj0x';
export const keyCloakConfig = {
    realm: process.env.REACT_APP_AUTH_REALM,
    clientId: process.env.REACT_APP_CLIENT_ID,
    url: process.env.REACT_APP_KEYCLOAK_URL,
};
//token has less than minValidity seconds left before it expires
export const TOKEN_MIN_VALIDITY_BEFORE_EXPIRATION = 60;
// As per keycloack documentation, -1 will force the token to be forcibly refreshed.
export const TOKEN_MIN_VALIDITY_TO_FORCE_UPDATE = -1;

export const headerLinks: INavGroup[] = [
    {
        title: 'LifeGraph',
        navLinks: [
            {
                title: 'Dashboard',
                path: SINGLE_NAVIGATION_PATHS.DASHBOARD,
                icon: 'mdi:view-dashboard',
            },
            {
                title: 'LifeGraph Explorer',
                path: SINGLE_NAVIGATION_PATHS.LIFEGRAPH,
                icon: 'mdi:graph',
                requiredRoles: requiredRoles.lifegraph,
            },
        ],
    },
    {
        title: 'Dictionaries',
        navLinks: [
            {
                title: 'Dictionary Editor',
                path: DICTIONARY_PATHS.LANDING_PAGE,
                icon: 'mdi:playlist-edit',
                requiredRoles: requiredRoles.dictionary,
            },
            {
                title: 'Edge Definitions',
                path: EDGE_DEFINITION_PATHS.LANDING_PAGE,
                icon: 'mdi:note-text',
                requiredRoles: requiredRoles.dictionary,
            },
        ],
    },
    {
        title: 'Contracts',
        navLinks: [
            {
                title: 'Consent Contracts',
                path: CONSENT_CONTRACT_PATHS.LANDING_PAGE,
                icon: 'mdi:share-all',
                requiredRoles: requiredRoles.consentContract,
            },
            {
                title: 'Smart Contracts',
                path: SMART_CONTRACT_PATHS.LANDING_PAGE,
                icon: 'mdi:code-tags',
                requiredRoles: requiredRoles.smartContract,
            },
        ],
    },
];

export const appRoutes = [
    // NOTE: Default route is in AppRoutes
    {
        // navigate to the dashboard if user enters the default path rather than adding `/dashboard` everywhere.
        path: SINGLE_NAVIGATION_PATHS.DEFAULT_PATH,
        component: 'Dashboard',
    },
    {
        path: SINGLE_NAVIGATION_PATHS.DASHBOARD,
        component: 'Dashboard',
    },
    {
        path: SINGLE_NAVIGATION_PATHS.SETTINGS,
        component: 'Settings',
    },
    {
        path: EDGE_DEFINITION_PATHS.LANDING_PAGE,
        component: 'EdgeDefinitions',
        roles: requiredRoles.dictionary,
    },
    {
        path: EDGE_DEFINITION_PATHS.CREATE_NEW_EDGE_DEFINITION,
        component: 'CreateEdgeDefinition',
        roles: requiredRoles.dictionary,
    },
    {
        path: EDGE_DEFINITION_PATHS.UPDATE_EDGE_DEFINITION,
        component: 'UpdateEdgeDefinition',
        roles: requiredRoles.dictionary,
    },
    {
        path: DICTIONARY_PATHS.LANDING_PAGE,
        component: 'Dictionaries',
        roles: requiredRoles.dictionary,
    },
    {
        path: DICTIONARY_PATHS.CREATE_NEW_DICTIONARY_VIEW,
        component: 'CreateDictionaryView',
        roles: requiredRoles.dictionary,
    },
    {
        path: DICTIONARY_PATHS.CREATE_NEW_DICTIONARY,
        component: 'CreateDictionary',
        roles: requiredRoles.dictionary,
    },
    {
        path: DICTIONARY_PATHS.UPDATE_DICTIONARY,
        component: 'EditDictionary',
        roles: requiredRoles.dictionary,
    },
    {
        path: DICTIONARY_PATHS.PREDICT_DICTIONARY,
        component: 'PredictDictionary',
        roles: requiredRoles.dictionary,
    },
    {
        path: CONSENT_CONTRACT_PATHS.LANDING_PAGE,
        component: 'ConsentContracts',
        roles: requiredRoles.consentContract,
    },
    {
        path: CONSENT_CONTRACT_PATHS.CREATE_NEW_CONSENT_CONTRACT,
        component: 'CreateConsentContract',
        roles: requiredRoles.consentContract,
    },
    {
        path: CONSENT_CONTRACT_PATHS.UPDATE_CONSENT_CONTRACT,
        component: 'UpdateConsentContract',
        roles: requiredRoles.consentContract,
    },
    {
        path: CONSENT_CONTRACT_PATHS.CONSENT_CONTRACT_RECEIPTS,
        component: 'ConsentContractReceipts',
        roles: requiredRoles.consentContract,
    },
    {
        path: SINGLE_NAVIGATION_PATHS.LIFEGRAPH,
        component: 'LifeGraphExplorerPage',
        roles: requiredRoles.lifegraph,
    },
    {
        path: SMART_CONTRACT_PATHS.LANDING_PAGE,
        component: 'SmartContracts',
    },
    {
        path: SMART_CONTRACT_PATHS.CREATE_NEW_SMART_CONTRACT,
        component: 'CreateSmartContract',
    },
    {
        path: SMART_CONTRACT_PATHS.UPDATE_SMART_CONTRACT,
        component: 'UpdateSmartContract',
    },
    {
        path: SMART_CONTRACT_PATHS.SMART_CONTRACT_RECEIPTS,
        component: 'SmartContractReceipts',
    },
    {
        path: SMART_CONTRACT_PATHS.EXECUTE_SMART_CONTRACT,
        component: 'ExecuteSmartContract',
    },
    {
        path: JOB_MANAGER_PATHS.LANDING_PAGE,
        component: 'JobManager',
        roles: requiredRoles.jobManager,
    },
    {
        path: JOB_MANAGER_PATHS.CREATE_NEW_JOB,
        component: 'CreateJobView',
        roles: requiredRoles.jobManager,
    },
    {
        path: JOB_MANAGER_PATHS.CREATE_UPLOAD_DICTIONARY_JOB,
        component: 'UploadDataDictionary',
        roles: requiredRoles.jobManager,
    },
    {
        path: JOB_MANAGER_PATHS.CREATE_DOWNLOAD_JOB,
        component: 'CreateDownloadJob',
        roles: requiredRoles.jobManager,
    },
    {
        path: JOB_MANAGER_PATHS.CREATE_UPLOAD_FILE_JOB,
        component: 'UploadFile',
        roles: requiredRoles.jobManager,
    },
    {
        path: JOB_MANAGER_PATHS.CREATE_DBSCHEMA_JOB,
        component: 'UploadDbSchema',
        roles: requiredRoles.jobManager,
    },
    {
        path: JOB_MANAGER_PATHS.CREATE_TRUNCATE_CHAIN_JOB,
        component: 'CreateTruncateChainJob',
        roles: requiredRoles.jobManager,
    },
    {
        path: JOB_MANAGER_PATHS.CREATE_EXECUTE_SMART_CONTRACT_JOB,
        component: 'CreateExecuteSmartContractJob',
        roles: requiredRoles.jobManager,
    },
    {
        path: JOB_MANAGER_PATHS.RESET_SDZ_DATA,
        component: 'CreateResetSDZData',
        roles: requiredRoles.jobManager,
    },
    {
        path: JOB_MANAGER_PATHS.WIPE_SDZ_DATA,
        component: 'CreateWipeSDZData',
        roles: requiredRoles.jobManager,
    },
    {
        path: SINGLE_NAVIGATION_PATHS.SYSTEM_MESSAGES,
        component: 'SystemMessages',
        roles: requiredRoles.systemMessages,
    },
    {
        path: SINGLE_NAVIGATION_PATHS.ASK_BLAST,
        component: 'AskBlast',
        roles: requiredRoles.askBlast,
    },
    {
        path: WALLETS_AND_GROUPS_PATHS.WALLETS_AND_GROUPS_PATH,
        component: 'WalletsAndGroups',
        roles: requiredRoles.walletsAndGroups,
    },
    {
        path: WALLETS_AND_GROUPS_PATHS.CREATE_NEW_WALLETS_AND_GROUPS_PATH,
        component: 'CreateWalletOrGroupView',
        roles: requiredRoles.walletsAndGroups,
    },
    {
        path: WALLETS_AND_GROUPS_PATHS.CREATE_NEW_USER_WALLET_PATH,
        component: 'CreateUserWallet',
        roles: requiredRoles.walletsAndGroups,
    },
    {
        path: WALLETS_AND_GROUPS_PATHS.EDIT_USER_WALLET_PATH + '/:id',
        component: 'UpdateUserWallet',
        roles: requiredRoles.walletsAndGroups,
    },
    {
        path: WALLETS_AND_GROUPS_PATHS.CREATE_NEW_SYSTEM_WALLET_PATH,
        component: 'CreateSystemWallet',
        roles: requiredRoles.walletsAndGroups,
    },
    {
        path: WALLETS_AND_GROUPS_PATHS.EDIT_SYSTEM_WALLET_PATH + '/:id',
        component: 'UpdateSystemWallet',
        roles: requiredRoles.walletsAndGroups,
    },
    {
        path: WALLETS_AND_GROUPS_PATHS.CREATE_NEW_USER_GROUP_PATH,
        component: 'CreateUserGroup',
        roles: requiredRoles.walletsAndGroups,
    },
    {
        path: WALLETS_AND_GROUPS_PATHS.EDIT_USER_GROUP_PATH + '/:id',
        component: 'UpdateUserGroup',
        roles: requiredRoles.walletsAndGroups,
    },
    {
        path: SINGLE_NAVIGATION_PATHS.INSUFFICIENT_PERMISSION_ERROR,
        component: 'InsufficientPermissionsError',
    },
    {
        path: SINGLE_NAVIGATION_PATHS.NOT_FOUND_ERROR,
        component: 'NotFoundError',
    },
    {
        path: SINGLE_NAVIGATION_PATHS.METADATA_SEARCH,
        component: 'MetadataSearch',
        roles: requiredRoles.metadataSearch,
    },
    {
        path: GLOSSARY_METADATA_PATHS.LANDING_PAGE,
        component: 'GlossaryMetadata',
        roles: requiredRoles.glossaryMetadata,
    },
    {
        path: GLOSSARY_METADATA_PATHS.CREATE_NEW_GLOSSARY_METADATA_VIEW,
        component: 'CreateGlossaryView',
        roles: requiredRoles.glossaryMetadata,
    },
    {
        path: GLOSSARY_METADATA_PATHS.CREATE_NEW_GLOSSARY_METADATA,
        component: 'CreateGlossaryMetadata',
        roles: requiredRoles.glossaryMetadata,
    },
    {
        path: GLOSSARY_METADATA_PATHS.CREATE_IMPORT_GLOSSARY_METADATA,
        component: 'ImportGlossaryMetadata',
        roles: requiredRoles.glossaryMetadata,
    },
    {
        path: GLOSSARY_METADATA_PATHS.UPDATE_GLOSSARY_METADATA,
        component: 'UpdateGlossaryMetadata',
        roles: requiredRoles.glossaryMetadata,
    },
    {
        path: SINGLE_NAVIGATION_PATHS.EXPORT,
        component: 'Export',
    },
    {
        path: JOB_MANAGER_PATHS.DROP_CHAIN,
        component: 'CreateDropChain',
    },
    {
        path: JOB_MANAGER_PATHS.EXPORT_DATA,
        component: 'CreateExportJob',
    },
    {
        path: PIPELINES_AND_STEPS_PATHS.LANDING_PAGE,
        component: 'Pipelines',
    },
    {
        path: PIPELINES_AND_STEPS_PATHS.CREATE_NEW_PIPELINE,
        component: 'CreatePipeline',
    },
    {
        path: PIPELINES_AND_STEPS_PATHS.PIPELINE_DETAILS,
        component: 'UpdatePipeline',
    },
    {
        path: PIPELINES_AND_STEPS_PATHS.CREATE_NEW_STEP,
        component: 'CreateStep',
    },
    {
        path: PIPELINES_AND_STEPS_PATHS.CREATE_NEW_STEP_DETAILS,
        component: 'StepForm',
    },
    {
        path: PIPELINES_AND_STEPS_PATHS.CREATE_FIELD_MAPPING,
        component: 'FieldMappingForm',
    },
    {
        path: PIPELINES_AND_STEPS_PATHS.CREATE_RULE_SET,
        component: 'CreateRuleForm',
    },
    {
        path: PIPELINES_AND_STEPS_PATHS.UPDATE_STEP_DETAILS,
        component: 'UpdateStep',
    },
    {
        path: SINGLE_NAVIGATION_PATHS.TQL_EDITOR,
        component: 'TQLEditorPage',
    },
];

export const APP_FONTS = [
    { family: 'open-sans', weights: [300, 400, 500, 600, 700, 800] },
    { family: 'raleway', weights: [300, 400, 500, 600, 700, 800] },
    { family: 'red-hat-display', weights: [300, 400, 500, 600, 700, 800] },
    { family: 'red-hat-text', weights: [300, 400, 500, 600, 700] },
    { family: 'red-hat-mono', weights: [300, 400, 500, 600, 700] },
    { family: 'source-code-pro', weights: [300, 400, 500, 600, 700, 800] },
];

export const excludedHeaderSidenavPaths = [
    DICTIONARY_PATHS.CREATE_NEW_DICTIONARY_VIEW,
    DICTIONARY_PATHS.PREDICT_DICTIONARY,
    EDGE_DEFINITION_PATHS.CREATE_NEW_EDGE_DEFINITION,
    JOB_MANAGER_PATHS.CREATE_NEW_JOB,
    JOB_MANAGER_PATHS.CREATE_UPLOAD_DICTIONARY_JOB,
    JOB_MANAGER_PATHS.CREATE_UPLOAD_FILE_JOB,
    JOB_MANAGER_PATHS.CREATE_DOWNLOAD_JOB,
    JOB_MANAGER_PATHS.CREATE_DBSCHEMA_JOB,
    JOB_MANAGER_PATHS.CREATE_TRUNCATE_CHAIN_JOB,
    JOB_MANAGER_PATHS.CREATE_EXECUTE_SMART_CONTRACT_JOB,
    WALLETS_AND_GROUPS_PATHS.CREATE_NEW_WALLETS_AND_GROUPS_PATH,
    WALLETS_AND_GROUPS_PATHS.CREATE_NEW_USER_WALLET_PATH,
    WALLETS_AND_GROUPS_PATHS.CREATE_NEW_SYSTEM_WALLET_PATH,
    WALLETS_AND_GROUPS_PATHS.CREATE_NEW_USER_GROUP_PATH,
    CONSENT_CONTRACT_PATHS.CREATE_NEW_CONSENT_CONTRACT,
    SMART_CONTRACT_PATHS.CREATE_NEW_SMART_CONTRACT,
    SMART_CONTRACT_PATHS.EXECUTE_SMART_CONTRACT,
    GLOSSARY_METADATA_PATHS.CREATE_NEW_GLOSSARY_METADATA,
    GLOSSARY_METADATA_PATHS.CREATE_IMPORT_GLOSSARY_METADATA,
    JOB_MANAGER_PATHS.RESET_SDZ_DATA,
    JOB_MANAGER_PATHS.WIPE_SDZ_DATA,
    JOB_MANAGER_PATHS.DROP_CHAIN,
    JOB_MANAGER_PATHS.EXPORT_DATA,
    SINGLE_NAVIGATION_PATHS.SETTINGS,
];
